import { getDaysOfRange, getAmountOfDaysBetween } from './date';

/**
 * Sums the precipitation of the weather response between two dates.
 * @param {Object} precipitationData
 * @param {String} startDate
 * @param {String} endDate
 * @return {Number}
 */
function sumPrecipitation(precipitationData, startDate, endDate) {
  const dates = Object.keys(precipitationData);
  const precipitation = Object.values(precipitationData);
  const startIndex = dates.findIndex((date) => date === startDate);
  const endIndex = dates.findIndex((date) => date === endDate);
  const precipitationValues = precipitation.slice(startIndex, endIndex + 1);
  return precipitationValues.reduce((sum, value) => sum + value, 0);
}

/**
 * Calculates the precipitation total of a given date based on the planting date.
 * @param {Object} precipitationData
 * @param {String} date
 * @param {String} plantingDate
 * @return {Number}
 */
export function calcPrecipitation(precipitationData = {}, date, plantingDate) {
  if (!date) {
    return 0;
  }
  const startDate =
    plantingDate && new Date(date) > new Date(plantingDate)
      ? plantingDate
      : `${date.split('-')[0]}-01-01`;
  return sumPrecipitation(precipitationData, startDate, date.split('T')[0]);
}

/**
 * Process GDU Response that builds a map where every key is a date in YYYY-MM-DD format and it's corresponding GDU value for that date
 * @param {Object} gduData
 * @param {String} year
 * @return {Object.<string, number>}  
 * */
export const processGdu = (data) => {
  const { q: gdus, first_date: firstDay, last_date: lastDay } = data.value.variables.gdu_accumulated;

  const yearGdus = getDaysOfRange(firstDay, lastDay).reduce(
    (result, day) => ({
      ...result,
      [day]:
        gdus[getAmountOfDaysBetween(firstDay, day)]
          ? Math.round(gdus[getAmountOfDaysBetween(firstDay, day)] * 100) / 100
          : null,
    }),
    {}
  );

  return yearGdus
}
